﻿

// ------------------------------------------------------------------------- //
// #TOGGLE
//
// To use the toggle module, add the class `.js-toggle` to an element and
// pass in the following data parameters:
//
// data-toggle-target   - Class or ID of the toggle target element
// data-toggle-effect   - Animation effect to use (fade or slide)
// data-toggle-duration - Animation duration for the toggle effect
// ------------------------------------------------------------------------- //


window.farmday = window.farmday || {};
farmday.modules = farmday.modules || {};


farmday.modules.toggle = (function () {
    var priv = {};
    var pub = {};


    /**
     * Toggle effects
     */
    priv.effect = {
        FADE: "fade",
        SLIDE: "slide"
    };


    /**
     * Toggle function
     */
    priv.function = {
        ACCORDION: "accordion"
    };


    /**
     * Private initialization method
     */
    priv.init = function () {

        /**
         * Expand correct toggle if provided in url (e.g. ?toggle=abc123)
         */
        if ($(".js-toggle").length) {
            var toggleId = gro.modules.url.getUrlParam("toggle");

            if (toggleId) {
                var toggle = $("[aria-controls='" + toggleId + "']");
                pub.show(toggle);
            }
        }

        /**
         * Toggle content
         */
        $(document).on("click", ".js-toggle", function (e) {
            var isCheckbox = $(e.target).is(":checkbox");
            var isChecked = false;

            if (isCheckbox) {
                isChecked = $(e.target).is(":checked");
            } else {
                e.preventDefault();
                e.stopPropagation();
            }

            var control = this;
            var target = $(this).data("toggle-target");
            var effect = $(this).data("toggle-effect");
            var duration = $(this).data("toggle-duration");
            var toggleFunction = $(this).data("toggle-function");
            var isVisible = priv.isVisible(target);

            if (isVisible && (!isCheckbox || (isCheckbox && !isChecked)))
                priv.hide(control, target, effect, duration);
            else if (!isVisible && (!isCheckbox || (isCheckbox && isChecked)))
                priv.show(control, target, effect, duration, toggleFunction);
        });


        /**
         * Trigger toggle from a different element than the toggle control itself
         */
        $(document).on("click", ".js-trigger-toggle", function () {
            var target = $(this).data("target");
            // Find all controls for toggle target (could be multiple)
            var controls = $(".js-toggle[data-target='" + target + "'");

            controls.each(function () {
                var isVisible = priv.isVisible(target);
                var effect = $(this).data("toggle-effect");
                var duration = $(this).data("toggle-duration");

                if (isVisible)
                    priv.hide(this, target, effect, duration);
                else
                    priv.show(this, target, effect, duration);
            });
        });
    };


    /**
     * Show content
     * @param {object} control - Toggle control
     * @param {object} target - Toggle target
     * @param {string} effect - Animation effect
     * @param {number} [duration=0] - Animation duration
     */
    priv.show = function (control, target, effect, duration, toggleFunction) {
        var value = $(control).attr("aria-controls");
        var updateUrl = $(control).data("toggle-url");

        // Set default duration if not provided
        if (duration === undefined)
            duration = 0;

        // If function is accordion, hide all siblings that is expanded
        if (toggleFunction === priv.function.ACCORDION) {
            $(control).siblings(".collapse__control.is-active").each(function () {
                var target = $(this).data("toggle-target");
                var effect = $(this).data("toggle-effect");
                var duration = $(this).data("toggle-duration");

                priv.hide(this, target, effect, duration);
            });
        }

        // Add classes to control before animating target to sync animations
        $(control)
            .addClass("is-active")
            .attr("aria-expanded", true);

        // Animation effects
        if (effect === priv.effect.FADE) {
            $(target).fadeIn(duration, function () {
                $(target)
                    .addClass("is-active")
                    .attr("aria-hidden", false)
                    .removeAttr("style");
            });
        } else if (effect === priv.effect.SLIDE) {
            $(target).slideDown(duration, function () {
                $(target)
                    .addClass("is-active")
                    .attr("aria-hidden", false)
                    .removeAttr("style");
            });
        }

        if (updateUrl) {
            // Add toggle id to querystring
            gro.modules.url.addUrlParam(document.location.search, "toggle", value);
        }
    };


    /**
     * Hide content
     * @param {object} control - Toggle control
     * @param {object} target - Toggle target
     * @param {string} effect - Animation effect
     * @param {number} [duration=0] - Animation duration
     */
    priv.hide = function (control, target, effect, duration) {
        // Set default duration if not provided
        if (duration === undefined)
            duration = 0;

        // Animation effect
        if (effect === priv.effect.FADE) {
            $(target).fadeOut(duration, function () {
                $(control)
                    .removeClass("is-active")
                    .attr("aria-expanded", false);

                $(target)
                    .removeClass("is-active")
                    .attr("aria-hidden", true)
                    .removeAttr("style");
            });
        } else if (effect === priv.effect.SLIDE) {
            $(target).slideUp(duration, function () {
                $(control)
                    .removeClass("is-active")
                    .attr("aria-expanded", false);

                $(target)
                    .removeClass("is-active")
                    .attr("aria-hidden", true)
                    .removeAttr("style");
            });
        }
    };


    /**
     * Check if an element is visible
     * @param {object} element - The element
     * @returns {boolean}
     */
    priv.isVisible = function (element) {
        return $(element).hasClass("is-active");
    };


    /**
     * Collapse all
     * @param {string} collapseContainer - The parent element of all accordion elements
     */
    pub.collapseAll = function (collapseContainer) {
        $(collapseContainer).find(".collapse__control").each(function () {
            var control = this;
            var target = $(control).data("toggle-target");

            priv.hide(control, target, "slide", 0);
        });
    };


    /**
     * Public show
     * @param {string} control - The collapse control element
     */
    pub.show = function (control) {
        var target = $(control).data("toggle-target");
        var effect = $(control).data("toggle-effect");
        var duration = $(control).data("toggle-duration");
        var toggleFunction = $(control).data("toggle-function");

        var isVisible = priv.isVisible(target);

        if (!isVisible)
            priv.show(control, target, effect, duration, toggleFunction);
    };


    /**
     * Public hide
     * @param {string} control - The collapse control element
     */
    pub.hide = function (control) {
        var target = $(control).data("toggle-target");
        var effect = $(control).data("toggle-effect");
        var duration = $(control).data("toggle-duration");

        var isVisible = priv.isVisible(target);

        if (isVisible)
            priv.hide(control, target, effect, duration);
    };


    // Initialize module
    $(function () {
        priv.init();
    });


    // Expose public methods
    return pub;

})();
